import * as React from "react"
import { keyframes } from "@emotion/react"
import { Skeleton, useTheme } from "@mui/material"
import { AppTableSeeker } from "@components"

import { availablesColumn, editColumn, productSkuColumn, validatedColumn, viewMappingsColumn } from "./columns"
import AdminSkuTableToolbarSelect from "./ToolbarSelect"
import { useAdminSkuFilters } from "../@hooks"


export default function AdminSkuTable() {
    const { palette } = useTheme()
    const { data, isLoading } = useAdminSkuFilters()

    if (isLoading)
        return <Skeleton variant="rectangular" height={700} />
    if (!data.length)
        return <></>

    return <AppTableSeeker
        title="SKUs in DB"
        data={data}
        columns={[
            ...productSkuColumn(),
            ...availablesColumn(),
            ...validatedColumn(),
            viewMappingsColumn(),
            editColumn()
        ]}
        options={{
            selectableRows: "multiple",
            customToolbarSelect: (selectedData, setSelectedRows) => <AdminSkuTableToolbarSelect
                selectedData={selectedData}
                setSelectedRows={setSelectedRows}
            />,
            enhancedSetRowProps: () => ({ sx: {
                "&:has(.is-loading)": {
                    animation: `${keyframes({
                        "0%": { backgroundColor: palette.info.light },
                        "100%": { backgroundColor: palette.info.lighter }
                    })} 1s linear infinite alternate`
                },
                "&:has(.is-clicked)": {backgroundColor: "warning.light"}
            } })
        }}
    />
}